<template>
    <div class="row g-3 mb-4">
        <!-- NAGŁÓWEK W SPÓJNYM STYLU Z PRZEWIJANIEM -->
        <div ref="headerRef" class="col-12 d-flex justify-content-between align-items-center border-bottom pb-2 cursor-pointer" @click="toggleSection">
            <h6 class="fw-bold mb-0">7. Cena i płatność</h6>
            <button type="button" class="btn btn-sm btn-link text-decoration-none p-0">
                <i class="bi" :class="sectionCollapse ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </button>
        </div>

        <!-- TREŚĆ SEKCJI -->
        <div class="col-12" v-show="sectionCollapse">
            <div class="row g-3">
                <div class="col-12 col-md-4">
                    <label class="form-label">Status płatności</label>
                    <select class="form-select" v-model="form.paymentStatus">
                        <option v-for="s in dicts?.paymentStatuses" :key="s" :value="s">{{ s }}</option>
                    </select>
                </div>
                <div class="col-12 col-md-4">
                    <label class="form-label">Typ płatności</label>
                    <select class="form-select" v-model="form.paymentType">
                        <option v-for="t in dicts?.paymentTypes" :key="t" :value="t">{{ t }}</option>
                    </select>
                </div>
                <div class="col-12 col-md-4">
                    <label class="form-label">Data zapłaty</label>
                    <input type="date" class="form-control" v-model="form.dueDate" />
                </div>

                <div class="col-12 col-md-4">
                    <label class="form-label">Waluta</label>
                    <select class="form-select" v-model="form.currency">
                        <option v-for="c in dicts?.currencies" :key="c" :value="c">{{ c }}</option>
                    </select>
                </div>
                <div class="col-12 col-md-4">
                    <label class="form-label">Powód zwolnienia z VAT</label>
                    <select class="form-select" v-model="form.vatExemptReason">
                        <option value="">Brak zwolnienia</option>
                        <option v-for="r in dicts?.vatExemptReasons" :key="r" :value="r">{{ r }}</option>
                    </select>
                </div>
                <div class="col-12 col-md-4">
                    <label class="form-label">Opis zwolnienia z VAT</label>
                    <input type="text" class="form-control" v-model="form.vatExemptDescription" />
                </div>

                <div class="col-12 col-md-3">
                    <label class="form-label">Nazwa banku</label>
                    <input type="text" class="form-control" v-model="seller.bankName" />
                </div>
                <div class="col-12 col-md-6">
                    <label class="form-label">Nr rachunku bankowego</label>
                    <input type="text" class="form-control" v-model="seller.bankAccount" />
                </div>
                <div class="col-12 col-md-3 d-flex align-items-end">
                    <button 
                        type="button" 
                        class="btn btn-outline-primary w-100 d-flex align-items-center justify-content-center gap-1"
                        :disabled="loadingDealerData"
                        @click="fetchDealerData"
                    >
                        <span v-if="loadingDealerData" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                        <i v-else class="bi bi-download"></i>
                        <span>Pobierz z konta dealera</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, nextTick } from 'vue'
import apiClient from '@/api'
import { webAlert } from '@/utils/dialog'

const props = defineProps({
    modelValue: {
        type: Object,
        required: true
    },
    sellerModel: {
        type: Object,
        default: () => ({ bankName: '', bankAccount: '' })
    },
    dicts: {
        type: Object,
        default: () => ({
            paymentStatuses: [],
            paymentTypes: [],
            currencies: [],
            vatExemptReasons: []
        })
    }
})

const emit = defineEmits(['update:modelValue', 'update:sellerModel'])

const headerRef = ref(null)
const sectionCollapse = ref(false)
const loadingDealerData = ref(false)

// Reaktywne dwukierunkowe wiązania
const form = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val)
})

const seller = computed({
    get: () => props.sellerModel || props.modelValue?.seller || {},
    set: (val) => emit('update:sellerModel', val)
})

const toggleSection = async () => {
    sectionCollapse.value = !sectionCollapse.value
    if (sectionCollapse.value) {
        await nextTick()
        headerRef.value?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
}

// Pobieranie danych bankowych z ustawień dealera
const fetchDealerData = async () => {
    loadingDealerData.value = true
    try {
        const response = await apiClient.post(
            {
                action: 'get-invoice-data'
            }
            
        )

        const resData = response.data

        if (resData?.data) {
            if (resData.data.bankName) {
                seller.value.bankName = resData.data.bankName
            }
            if (resData.data.bankAccount) {
                seller.value.bankAccount = resData.data.bankAccount
            }
        } else if (resData?.message) {
            webAlert(resData)
        } else {
            webAlert('Nie udało się pobrać danych dealera.')
        }
    } catch (error) {
        console.error('Błąd podczas pobierania danych dealera:', error)
        webAlert('Wystąpił błąd podczas połączenia z API.')
    } finally {
        loadingDealerData.value = false
    }
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
    user-select: none;
}
</style>